export default __webpack_public_path__ + "static/media/shvm.b5ae8187.jpg";